module.exports = __webpack_public_path__ + "assets/images/assessment-growth.f5a850eabefa205babe3f06b8ef60caa.svg";